module.exports = __webpack_public_path__ + "img/mauryans-barbarian.0ccb1245.png";